(() => {
  const desktopNavigation = window.matchMedia('(min-width: 1280px)');

  const setCartLabel = (button) => {
    const countElement = button.querySelector('[data-cart-quantity]');
    const count = Number.parseInt(countElement?.textContent || '0', 10) || 0;
    button.setAttribute('aria-label', `Open cart, ${count} ${count === 1 ? 'item' : 'items'}`);
  };

  const enhanceHeader = (header) => {
    const drawer = header.querySelector('[data-js-header-nav]');
    const drawerOpeners = [...header.querySelectorAll('[data-js-open-mobile-nav]')];
    const drawerOverlay = header.querySelector('.header__nav-overlay');
    const searchPanel = header.querySelector('.header__search');
    const searchOpeners = [...header.querySelectorAll('[data-js-search-icon]')];
    const cartButton = header.querySelector('[data-js-main-cart-btn]');

    const openDrawerFallback = (opener) => {
      if (!drawer || desktopNavigation.matches || header.classList.contains('is-opened')) return;

      // Some older Android WebViews throw while registering listeners with an
      // AbortSignal. Keep the mobile navigation usable even if the primary
      // section-header controller could not finish binding its events.
      header.mobileMenuOpen = true;
      header.mobileReturnFocus = opener || document.activeElement;
      drawer.style.display = 'block';
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpeners.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.documentElement.classList.add('overflow-hidden');
      header.classList.add('is-opened');
      drawer.querySelector('[data-js-close-mobile-nav]')?.focus();
    };

    const closeDrawerFallback = (restoreFocus = true) => {
      if (!drawer || !header.classList.contains('is-opened')) return;

      header.mobileMenuOpen = false;
      header.classList.remove('is-opened');
      drawer.classList.remove('sub-opened');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      drawerOpeners.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.documentElement.classList.remove('overflow-hidden');
      document.dispatchEvent(new CustomEvent('mega-menu:close-all'));
      document.dispatchEvent(new CustomEvent('mobile-menu:close'));

      window.setTimeout(() => {
        if (!header.classList.contains('is-opened')) drawer.style.display = '';
      }, 300);
      if (restoreFocus) header.mobileReturnFocus?.focus?.();
    };

    drawerOpeners.forEach((opener) => {
      opener.addEventListener('click', () => {
        // Let the native controller run first. If it did not open the drawer,
        // recover on the next frame without double-toggling a healthy menu.
        window.requestAnimationFrame(() => openDrawerFallback(opener));
      });
    });

    header.querySelectorAll('[data-js-close-mobile-nav], .header__nav-overlay').forEach((closer) => {
      closer.addEventListener('click', () => {
        window.requestAnimationFrame(() => closeDrawerFallback());
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawerFallback();
    });

    // Search and cart remain ordinary links if their theme controllers fail.
    // Suppress navigation only when the enhanced panel/drawer is registered.
    searchOpeners.forEach((opener) => {
      if (!(opener instanceof HTMLAnchorElement)) return;
      opener.addEventListener('click', (event) => {
        if (customElements.get('section-header') && searchPanel) event.preventDefault();
      });
    });

    if (cartButton instanceof HTMLAnchorElement) {
      cartButton.addEventListener('click', (event) => {
        if (customElements.get('section-cart') && document.querySelector('section-cart')) {
          event.preventDefault();
        }
      });
    }

    const syncDrawer = () => {
      if (!drawer) return;

      const isOpen = header.classList.contains('is-opened');
      const isDesktop = desktopNavigation.matches;
      const isHidden = !isDesktop && !isOpen;

      document.documentElement.classList.toggle('mobile-navigation-open', isOpen && !isDesktop);
      document.body?.classList.toggle('mobile-navigation-open', isOpen && !isDesktop);

      drawer.setAttribute('aria-hidden', String(isHidden));
      drawer.toggleAttribute('inert', isHidden);
      drawerOpeners.forEach((opener) => opener.setAttribute('aria-expanded', String(isOpen)));

      if (drawerOverlay) {
        drawerOverlay.tabIndex = isOpen ? 0 : -1;
      }
    };

    const syncSearch = () => {
      if (!searchPanel) return;

      const isOpen = searchPanel.classList.contains('active');
      searchPanel.setAttribute('aria-hidden', String(!isOpen));
      searchOpeners.forEach((opener) => {
        opener.setAttribute('aria-expanded', String(isOpen));
        opener.setAttribute('aria-label', isOpen ? 'Close search' : 'Open search');
      });
    };

    new MutationObserver(syncDrawer).observe(header, {
      attributes: true,
      attributeFilter: ['class'],
    });

    if (searchPanel) {
      new MutationObserver(syncSearch).observe(searchPanel, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    header.querySelectorAll('details.header__nav__mega-menu-details').forEach((details) => {
      const summary = details.querySelector('summary');
      const syncDetails = () => summary?.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', syncDetails);
      syncDetails();
    });

    if (cartButton) {
      const countElement = cartButton.querySelector('[data-cart-quantity]');
      setCartLabel(cartButton);

      if (countElement) {
        new MutationObserver(() => setCartLabel(cartButton)).observe(countElement, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    desktopNavigation.addEventListener('change', syncDrawer);
    document.addEventListener('mobile-menu:close', syncDrawer);
    syncDrawer();
    syncSearch();
  };

  document.querySelectorAll('section-header').forEach(enhanceHeader);
})();
